import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { MixedCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { MIX_CHART } from "../../../../Data/Charts/ApexChart";

const MixedChart = () => {
  return (
    <Col sm="12" xl="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={MixedCharts} />
        <CardBody>
          <div id="mixedchart">
            <Chart options={MIX_CHART} series={MIX_CHART.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MixedChart;
